import { defineStore } from "pinia";

const generateRandomNumericId = (length = 10) => {
    length = length < 1 ? 8 : length;
    const min = Math.pow(10, length - 1);
    const max = Math.pow(10, length) - 1;
    return Math.floor(min + Math.random() * (max - min + 1)).toString();
};

/**
 * We are not resettings "paymentReferenceId" here when order is reset.
 * For each order a unique payment reference ID is generated.
 * This is to ensure that each order can be uniquely identified in the server end.
 * This will be passesed as a reference ID to the payment gateway.
 * We will cross match this ID when the backend broadcasts the payment event
 * to the frontend and then we cross match and send the order request to the server. 
 */
export const usePaymentSettings = defineStore("paymentSettings", {
    state: () => ({
        paymentReferenceId: generateRandomNumericId(8),
        promptPayMerchantId: "",
    }),
    actions: {
        getPaymentReferenceId() {
            return this.paymentReferenceId;
        },
        getPromptPayMerchantId() {
            return this.promptPayMerchantId;
        },
        setPaymentReferenceId(id = null) {
            this.paymentReferenceId = id || generateRandomNumericId(8);
        },
        setPromptPayMerchantId(merchantId) {
            this.promptPayMerchantId = merchantId;
        },
        resetPaymentSettings() {
            this.paymentReferenceId = generateRandomNumericId(8);
            this.promptPayMerchantId = "";
        },
    },
    persist: {
        storage: localStorage,
        paths: ["paymentReferenceId", "promptPayMerchantId"],
    },
});
